import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              关于海角网，你想知道的都在这里
            </p>
          </div>
          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="rounded-xl border border-background-200/60 bg-background-100 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenId(openId === item.id ? null : item.id)}
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <i
                    className={`text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                      openId === item.id ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openId === item.id ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}